import { createAsyncThunk } from "@reduxjs/toolkit";
import { showSnackbar } from "../../snackbar/Snackbar.slice";
import {
  get,
  isEndpointNotAvailable,
} from "../../../services/apiService";
import { normalizeKycListResponse } from "./kycStatusUtils";

const KYC_VERIFICATIONS_LIST = "kycStatusList/fetch";
const KYC_LIST_ENDPOINT = "/kyc-verifications";

export const KYC_LIST_UNAVAILABLE_MESSAGE =
  "KYC verifications API is not available (GET /kyc-verifications). Contact backend support.";

const buildApiQueryParams = ({
  page,
  page_size,
  status_filter,
  merchant_id,
  is_admin,
  search,
  client_info_id,
  email,
}) => {
  const params = {
    page,
    page_size,
    ...(status_filter &&
      status_filter !== "all" && { status: status_filter }),
  };

  if (search) {
    params.search = search;
  } else {
    if (client_info_id != null && client_info_id !== "") {
      params.client_info_id = client_info_id;
    }
    if (email) params.email = email;
  }

  if (is_admin) {
    if (merchant_id) params.merchant_id = merchant_id;
  } else if (merchant_id) {
    params.merchant_id = merchant_id;
  }

  return params;
};

const fetchApiVerifications = async ({
  token,
  page,
  page_size,
  status_filter,
  merchant_id,
  is_admin,
  search,
  client_info_id,
  email,
}) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: buildApiQueryParams({
      page,
      page_size,
      status_filter,
      merchant_id,
      is_admin,
      search,
      client_info_id,
      email,
    }),
  };

  const result = await get(KYC_LIST_ENDPOINT, config);
  return normalizeKycListResponse(result, page, page_size);
};

export const fetchKycVerifications = createAsyncThunk(
  KYC_VERIFICATIONS_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        page = 1,
        page_size = 10,
        status_filter = "all",
        merchant_id,
        is_admin = false,
        search,
        client_info_id,
        email,
      } = payload;

      if (!token) {
        throw new Error("Authentication token is required");
      }

      if (!is_admin && !merchant_id) {
        throw new Error("Merchant ID is required for KYC verifications list");
      }

      return await fetchApiVerifications({
        token,
        page,
        page_size,
        status_filter,
        merchant_id,
        is_admin,
        search,
        client_info_id,
        email,
      });
    } catch (error) {
      console.error("Error fetching KYC verifications:", error);

      if (isEndpointNotAvailable(error)) {
        dispatch(
          showSnackbar({
            message: KYC_LIST_UNAVAILABLE_MESSAGE,
            severity: "warning",
          })
        );
        return rejectWithValue({
          message: KYC_LIST_UNAVAILABLE_MESSAGE,
          endpointMissing: true,
        });
      }

      const fallback = "Unable to load KYC verifications. Please try again.";
      dispatch(
        showSnackbar({
          message: fallback,
          severity: "error",
        })
      );

      return rejectWithValue({
        message: fallback,
      });
    }
  }
);
